import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import login from "../Assets/hall (3).jpeg";
import { API_URI } from "../Common/data";
import Loader from "../loader/Loader";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function Login() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    mobile: "",
    password: "",
    otp: "",
  });
  const [loading, setLoading] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpLoginSent, setotpLoginSent] = useState(false);
  const [otpData, setOtpData] = useState({
    mobile: "",
    otp: "",
    newPassword: "",
  });
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [forgotTimer, setForgotTimer] = useState(30);
  const [canResendForgot, setCanResendForgot] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleForgotChange = (e) => {
    setOtpData({ ...otpData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { mobile } = formData;

    if (!mobile) {
      toast.error("Mobile number is required!");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(`${API_URI}/user/login`, formData);
      if (response.status === 200) {
        setLoading(false);
        toast.success("OTP sent!");
        setotpLoginSent(true);
        setTimer(30);
        setCanResend(false);
      }
    } catch (error) {
      setLoading(false);
      const errorMsg =
        error.response?.data?.message || "Invalid credentials, try again!";
      toast.error(errorMsg);
    }
  };

  const handleResendOtpLogin = async () => {
    try {
      setLoading(true);
      await axios.post(`${API_URI}/user/login`, {
        mobile: formData.mobile,
        password: formData.password,
      });
      setLoading(false);
      toast.success("OTP resent to your mobile!");
      setTimer(30);
      setCanResend(false);
    } catch (error) {
      setLoading(false);
      toast.error("Failed to resend OTP.");
    }
  };

  const handleVerifyOtp = async () => {
    const { mobile, otp } = formData;
    if (!otp) {
      toast.error("Please enter the OTP!");
      return;
    }
    if (!mobile) {
      toast.error("Please enter the mobile number!");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(`${API_URI}/user/login/verify`, {
        mobile,
        otp,
      });

      if (response.status === 200) {
        toast.success("Login successful!");
        const data = response?.data?.data;
        localStorage.setItem("cine_user", JSON.stringify(data?.user));
        localStorage.setItem("cine_userToken", data?.tokens?.accessToken);
        navigate("/");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Invalid OTP!");
    } finally {
      setLoading(false);
    }
  };

  const handleForgotSubmit = async () => {
    if (!otpData.mobile) {
      toast.error("Please enter your mobile!");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(`${API_URI}/user/forgot/otpsend`, {
        mobile: otpData.mobile,
      });

      if (response.status === 200) {
        setLoading(false);
        toast.success("OTP sent to your mobile!");
        setOtpSent(true);
        setForgotTimer(30);
        setCanResendForgot(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error.response?.data?.message || "Error sending OTP!");
    }
  };

  const handleResendForgotOtp = async () => {
    try {
      setLoading(true);
      await axios.post(`${API_URI}/user/forgot/otpsend`, {
        mobile: otpData.mobile,
      });
      toast.success("OTP resent!");
      setForgotTimer(30);
      setCanResendForgot(false);
    } catch (error) {
      toast.error("Failed to resend OTP.");
    } finally {
      setLoading(false);
    }
  };

  const handleOtpVerify = async () => {
    const { mobile, otp, newPassword } = otpData;
    if (!otp || !newPassword) {
      toast.error("Please enter OTP and new password!");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(`${API_URI}/user/forgot/otpverify`, {
        mobile,
        otp,
        password: newPassword,
      });

      if (response.status === 200) {
        setLoading(false);
        toast.success("Password reset successful! You can now login.");
        setForgotPassword(false);
        setOtpSent(false);
        setFormData({ mobile: "", password: "", otp: "" });
      }
    } catch (error) {
      setLoading(false);
      toast.error(error.response?.data?.message || "Invalid OTP!");
    }
  };

  useEffect(() => {
    let interval;
    if (otpLoginSent && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setCanResend(true);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [otpLoginSent, timer]);

  useEffect(() => {
    let interval;
    if (otpSent && forgotTimer > 0) {
      interval = setInterval(() => {
        setForgotTimer((prev) => prev - 1);
      }, 1000);
    } else if (forgotTimer === 0) {
      setCanResendForgot(true);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [otpSent, forgotTimer]);

  useEffect(() => {
    document.body.classList.add("auth-page-active");

    return () => {
      document.body.classList.remove("auth-page-active");
    };
  }, []);

  return (
    <>
      <Navbar />
      <section className="auth-shell auth-shell--login">
        <div className="auth-shell__inner">
          <div className="auth-panel">
            <div className="auth-panel__copy">
              <p className="auth-panel__eyebrow">
                {forgotPassword ? "Recovery" : "Welcome Back"}
              </p>
              <h1>
                {forgotPassword
                  ? "Reset access and get back to your bookings."
                  : "Pick up your celebration journey in a few quick steps."}
              </h1>
              <p className="auth-panel__text">
                {forgotPassword
                  ? "We will send an OTP to your registered mobile number so you can set a new password securely."
                  : "Use your mobile number to receive an OTP and sign in without friction."}
              </p>
            </div>

            <div className="auth-card">
              {forgotPassword ? (
                <>
                  <div className="auth-card__header">
                    <p className="auth-panel__eyebrow">Forgot Password</p>
                    <h3>{otpSent ? "Verify OTP" : "Send recovery OTP"}</h3>
                    <p>
                      {otpSent
                        ? "Enter the OTP you received and choose a new password."
                        : "Start by entering your registered mobile number."}
                    </p>
                  </div>

                  <div className="auth-form">
                    {!otpSent ? (
                      <>
                        <label>Mobile Number</label>
                        <input
                          name="mobile"
                          type="text"
                          placeholder="Enter mobile number"
                          value={otpData.mobile}
                          onChange={handleForgotChange}
                        />
                        <button
                          type="button"
                          disabled={loading}
                          onClick={handleForgotSubmit}
                        >
                          {loading ? <Loader /> : "Send OTP"}
                        </button>
                      </>
                    ) : (
                      <>
                        <label>OTP</label>
                        <input
                          name="otp"
                          type="text"
                          placeholder="Enter OTP"
                          value={otpData.otp}
                          onChange={handleForgotChange}
                        />
                        <label>New Password</label>
                        <input
                          name="newPassword"
                          type="password"
                          placeholder="Enter new password"
                          value={otpData.newPassword}
                          onChange={handleForgotChange}
                        />
                        <button
                          type="button"
                          disabled={loading}
                          onClick={handleOtpVerify}
                        >
                          {loading ? <Loader /> : "Reset Password"}
                        </button>
                        <div className="auth-inline-meta">
                          {!canResendForgot ? (
                            <p>Resend OTP in {forgotTimer}s</p>
                          ) : (
                            <button
                              type="button"
                              className="auth-text-button"
                              onClick={handleResendForgotOtp}
                              disabled={loading}
                            >
                              {loading ? "Resending..." : "Resend OTP"}
                            </button>
                          )}
                        </div>
                      </>
                    )}
                  </div>

                  <button
                    type="button"
                    className="auth-text-button auth-text-button--back"
                    onClick={() => {
                      setForgotPassword(false);
                      setOtpSent(false);
                    }}
                  >
                    Back to login
                  </button>
                </>
              ) : (
                <>
                  <div className="auth-card__header">
                    <p className="auth-panel__eyebrow">Sign In</p>
                    <h3>{otpLoginSent ? "Enter OTP" : "Verify your mobile"}</h3>
                    <p>
                      {otpLoginSent
                        ? "We have sent a one-time password to your mobile number."
                        : "Enter your mobile number and we will send you a login OTP."}
                    </p>
                  </div>

                  <div className="auth-form">
                    <label>Mobile Number</label>
                    <input
                      name="mobile"
                      type="text"
                      placeholder="Enter mobile number"
                      value={formData.mobile}
                      onChange={handleChange}
                      disabled={otpLoginSent}
                    />

                    {otpLoginSent && (
                      <>
                        <label>OTP</label>
                        <input
                          name="otp"
                          type="text"
                          placeholder="Enter OTP"
                          value={formData.otp}
                          onChange={handleChange}
                        />
                      </>
                    )}

                    <button
                      type="button"
                      disabled={loading}
                      onClick={otpLoginSent ? handleVerifyOtp : handleSubmit}
                    >
                      {loading ? <Loader /> : otpLoginSent ? "Login" : "Send OTP"}
                    </button>

                    {otpLoginSent ? (
                      <div className="auth-inline-meta">
                        {!canResend ? (
                          <p>Resend OTP in {timer}s</p>
                        ) : (
                          <button
                            type="button"
                            className="auth-text-button"
                            onClick={handleResendOtpLogin}
                            disabled={loading}
                          >
                            {loading ? "Resending..." : "Resend OTP"}
                          </button>
                        )}
                      </div>
                    ) : (
                      <div className="auth-inline-meta auth-inline-meta--spread">
                        <button
                          type="button"
                          className="auth-text-button"
                          onClick={() => setForgotPassword(true)}
                        >
                          Forgot password?
                        </button>
                        <button
                          type="button"
                          className="auth-text-button"
                          onClick={() => navigate("/signup")}
                        >
                          Create account
                        </button>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>

          <aside className="auth-visual auth-visual--login">
            <div className="auth-visual__frame">
              <img src={login} alt="Login" />
            </div>
            <div className="auth-visual__note">
              <span>Quick access</span>
              <strong>Bookings, profile details, and support all in one place</strong>
            </div>
          </aside>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Login;
